import React, { useEffect, useRef, useState } from 'react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import {
  getCostResponsibility,
  createCostResponsibility,
  updateCostResponsibility,
  deleteCostResponsibility,
} from '../api/cost-responsibilityAPI';
import { fetchData } from '../utils/apiHelpers';
import { useFormBuilder } from '../utils/useFormBuilder';
import { Icon } from '@iconify/react';
import $ from 'jquery';

const CostResponsibilityLayer = () => {
  const userProfile = useUserProfile();
  const [responsibilities, setResponsibilities] = useState([]);
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const fetchResponsibilities = () => {
    fetchData(getCostResponsibility, {}, setResponsibilities);
  };

  useEffect(() => {
    fetchResponsibilities();
  }, []);

  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (responsibilities.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({ pageLength: 25, dom: 'rtip' });
    }
    return () => dtRef.current?.destroy(true);
  }, [responsibilities]);

  useEffect(() => {
    dtRef.current?.search(searchTerm).draw();
  }, [searchTerm]);

  const inputFields = [
    { field: 'name', label: 'Responsibility', type: 'text', size: 12, required: true },
  ];

  const { renderField } = useFormBuilder(inputFields, formData, setFormData, errors);

  const validateForm = () => {
    const errs = {};
        if (!formData.name?.trim()) errs.name = 'Responsibility is required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    const payload = {};
    for (const key in formData) {
      if (formData[key] !== null && typeof formData[key] !== 'object') {
        payload[key] = formData[key];
      }
    }
    if (editingId) await updateCostResponsibility(editingId, payload);
    else await createCostResponsibility(payload);

    setShowModal(false);
    setEditingId(null);
    setFormData({});
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    fetchResponsibilities();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete cost responsibility?')) return;
    await deleteCostResponsibility(id);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    fetchResponsibilities();
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between p-3">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {userProfile?.privileges?.includes('cost-responsibility:create') && (
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={() => {
              setFormData({});
              setEditingId(null);
              setShowModal(true);
            }}
          >
            <Icon icon="ic:baseline-plus" className="icon text-xl" /> Add Cost Responsibility
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table ref={tableRef} className="table bordered-table mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {responsibilities.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('cost-responsibility:update') && (
                        <button
                          className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => {
                            setFormData(item);
                            setEditingId(item.id);
                            setShowModal(true);
                          }}
                        >
                          <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('cost-responsibility:delete') && (
                        <button
                          className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Cost Responsibility' : 'New Cost Responsibility'}</h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3">{inputFields.map(renderField)}</div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CostResponsibilityLayer;
